import BaseAPI from '@/apis/base/baseApi';

class WebsiteIpAPI extends BaseAPI {
	constructor() {
		super();
	}
	apiName = 'Business';
	controllerName = 'websiteIp';
}

export default new WebsiteIpAPI();
